import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { RadioListItem } from 'components/Input/Radio';

const DialogRadioVersion = ({ isOpenRadio, setIsOpenRadio, form, handleSubmit }) => {

    useEffect(() => {
        if (isOpenRadio) {
            form.setValue("isSaveVersion", "0")
        }
    }, [form, isOpenRadio])

    return (
        <DialogPreview
            IsOpen={isOpenRadio}
            Title={"ยืนยันการปรับแผน"}
            sMaxWidth="sm"
            JsxDialogAction
            CloseSave={false}
            Close={false}
            onCustomButton={
                <Grid
                    container
                    spacing={2}
                    justifyContent={"center"}
                >
                    <Grid item >
                        <BtnBack id={"BtnBack"} onClick={() => setIsOpenRadio(false)} />
                    </Grid>
                    <Grid item >
                        <BtnSave id={"BtnSave"} onClick={() => handleSubmit("S")} />
                    </Grid>
                </Grid>
            }
        >
            <Grid container spacing={1} justifyContent={"center"} alignItems={"start"}>
                <Grid item xs={12}>
                    <RadioListItem
                        id={"isSaveVersion"}
                        name={"isSaveVersion"}
                        label={`เป็นการปรับแผนหรือไม่ ?`}
                        required={true}
                        options={[
                            { value: "1", label: "ใช่" },
                            { value: "0", label: "ไม่" }
                        ]}
                    />
                </Grid>
            </Grid>
        </DialogPreview>
    )
}

export default DialogRadioVersion
